import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_DEALS } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetDeals = function*() {
  yield takeLatest(GET_DEALS, workerGetDeals);
};

function* workerGetDeals(Param) {
  const result = yield call(getDeals, Param);
  yield put({ type: "SET_DEALS", json: result.data });
}

function getDeals(Param) {
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.get(apiUrl + "deals/listdeals?" + Param.params, options).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}
